import React from 'react';

export const CampaignAdd = (props) => (
  <svg
    fill="none"
    height="66"
    viewBox="0 0 67 66"
    width="67"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      height="28.8143"
      rx="6.1745"
      stroke="#6515DD"
      strokeWidth="4.11633"
      width="28.8143"
      x="2.75152"
      y="2.05817"
    />
    <rect
      height="28.8143"
      rx="6.1745"
      stroke="#6515DD"
      strokeWidth="4.11633"
      width="28.8143"
      x="35.6822"
      y="34.9898"
    />
    <path
      d="M17.1582 37.0469V45.2795C17.1582 47.5529 19.0011 49.3959 21.2745 49.3959H29.5072"
      stroke="#6515DD"
      strokeWidth="4.11633"
    />
    <path
      d="M50.0889 28.8145L50.0889 20.5818C50.0889 18.3084 48.2459 16.4655 45.9725 16.4655L37.7399 16.4655"
      stroke="#6515DD"
      strokeWidth="4.11633"
    />
    <path
      className="plus"
      d="M51.5284 41.3027V47.5342H57.4407V50.3156H51.5284V56.5775H48.4886V50.3156H42.6067V47.5342H48.4886V41.3027H51.5284Z"
      fill="#6515DD"
    />
  </svg>
);
